import { useState } from 'react';
import EDLink from '../../../../../../BaseComponents/Link/EDLink';
import EDTooltip from '../../../../../../BaseComponents/Tooltip/EDTooltip';
import { CookieSettingsDialog } from '../../../../../../Components/CookieSettings/CookieSettingsDialog';
import { IConsent } from '../../../../../../Components/CookieSettings/CookieSettingsUtils';

interface IProps {
  consent: IConsent;
  setConsent: (consent: IConsent) => void;
  startOpen?: boolean;
  onClose?: () => void;
}

/**
 * En länk som öppnar upp en dialog med en Cookie policy som laddas från avenydata.se
 */
export const CookieSettingsLink: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const [dialogOpen, setDialogOpen] = useState(props.startOpen ?? false);

  return (
    <>
      <EDTooltip
        title={'Klicka här för att ställa in hur Aveny samlar in data'}
      >
        <EDLink
          onClick={event => {
            event.preventDefault();
            event.stopPropagation();
            setDialogOpen(true);
          }}
        >
          Inställningar för datainsamling
        </EDLink>
      </EDTooltip>
      <CookieSettingsDialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
          props.onClose && props.onClose();
        }}
        consent={props.consent}
        setConsent={props.setConsent}
      />
    </>
  );
};
